module.exports = __webpack_public_path__ + "img/yz_6@2x.42bbb93f.png";